import React from 'react';
const CollapseOpenCloseButton = ({ children }) => {
	return <div id={'open-close-button'}>{children}</div>;
};

export default CollapseOpenCloseButton;
